export default function setTechnicianAffected(
  { commit, getters, rootGetters },
  { requestId, technicianId }
) {
  if (getters.active && getters.active.id === requestId) {
    commit('SET_CURRENT', {
      ...getters.active,
      technician_internal_id: technicianId,
    });
  }
  const requestItems = getters.items;
  let index = requestItems.findIndex((el) => el.id === requestId);
  if (index >= 0) {
    const oldItem = requestItems[index];
    requestItems[index] = {
      ...oldItem,
      technician_internal_id: technicianId,
    };
    commit('SET_ITEMS', requestItems);
  }
  const dispatchedItems = rootGetters['requests/dispatched/items'];
  index = dispatchedItems.findIndex((el) => el.request_id === requestId);
  if (index >= 0) {
    const oldItem = dispatchedItems[index];
    dispatchedItems[index] = {
      ...oldItem,
      technician_internal_id: technicianId,
    };
    commit('requests/dispatched/SET_ITEMS', dispatchedItems, { root: true });
  }
}
